import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { ProductReviewModel } from 'app/model/products/product-review.model';

@Component({
  selector: 'act-info-window-content',
  templateUrl: './info-window-content.component.html',
  styleUrls: ['./info-window-content.component.scss']
})
export class InfoWindowContentComponent implements OnInit {

  displayNavigate;

  private _image: String;
  @Input() set image(image: String) {
    this._image = image;
  }

  private _title: String;
  @Input() set title(title: String) {
    this._title = title;
  }

  private _isActive: Boolean = true;
  @Input() set isActive(isActive: Boolean) {
    this._isActive = isActive || this._isActive;
  }
  private ratingArray = [];
  @Input() set rating(rating: number) {
    this.ratingArray = this.utilitiesService.indexToArray(rating);
  }

  private reviewRating: ProductReviewModel;
  @Input() set review(review: ProductReviewModel) {
    this.reviewRating = review;
  }

  @Input() latitude;
  @Input() longitude;

  constructor(
    private utilitiesService: UtilitiesService,
    private ref: ChangeDetectorRef
  ) { }

  // tslint:disable-next-line:no-unused-variable
  private MINTOTALNUMBEROFSUBMITBEFORESHOW = 6;

  ngOnInit() {
  }

  setData(image: String, title: String, rating: Number, review: ProductReviewModel, isActive: Boolean = true, displayNavigate = false) {
    this._image = image;
    this._title = title;
    this._isActive = isActive;
    this.ratingArray = this.utilitiesService.indexToArray(rating);
    this.reviewRating = review;
    this.displayNavigate = displayNavigate;
    this.ref.detectChanges();
  }

  onNavigate() {
    window.open(`https://www.google.com/maps/dir/?api=1&travelmode=driving&destination=${this.latitude},${this.longitude}`, '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-map-nearby/info-window-content/info-window-content.component.ts